import { render } from "./LoadingIcon.vue?vue&type=template&id=17fcbc59&ts=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&lang=ts"

import "./LoadingIcon.vue?vue&type=style&index=0&id=17fcbc59&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__